// extracted by mini-css-extract-plugin
export default {"wrapper":"qp-z","response":"rp-z","error":"sp-z","disabled":"tp-z","buttons":"up-z","feedbackQuestionSection":"vp-z","yesNoWrapper":"wp-z"};